import { render, staticRenderFns } from "./AssumptionsImpacts.vue?vue&type=template&id=5d16a490&scoped=true&"
import script from "./AssumptionsImpacts.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpacts.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsImpacts.vue?vue&type=style&index=0&id=5d16a490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d16a490",
  null
  
)

export default component.exports